import { SET_SELECTED_FARE_GROUP } from './actions';
const defaultState = 'Standard';
export const selectedFareGroupReducer = (state = defaultState, action) => {
    if (action.type === SET_SELECTED_FARE_GROUP) {
        return action.payload;
    }
    return state;
};
